import { store } from 'app/store'
import wheeler_2 from 'Assets/2_wheeler.svg'
import wheeler_4 from 'Assets/4_wheeler.svg'
import pcv from 'Assets/PCV-LineIcon.svg'
import gcv from 'Assets/GCV-LineIcon.svg'
import misc from 'Assets/miscellaneous.svg'

import {
  daughter_logo,
  father_logo,
  mother_logo,
  self_logo,
  son_logo,
  spouse_logo,
} from 'Assets/Health'
import { subDays, subYears } from 'date-fns'
import { getAesKeyHex, getIvString } from 'Utils/obfSecret'

export const HEADER_HEIGHT = 70
export const BASE_URL = process.env.REACT_APP_BASE_URL ?? ''
export const FOUNDATION_URL = process.env.REACT_APP_FOUNDATION_URL ?? ''
export const HEALTH_URL = process.env.REACT_APP_HEALTH ?? ''
export const MISC_URL = 'http://misc.theblackswan.in'

// BOB endpoints
export const REACT_APP_REDIRECTION_URL = process.env.REACT_APP_REDIRECTION_URL ?? ''
export const BOB_CUSTOMER_URL = process.env.REACT_APP_BOB_CUSTOMER_URL ?? ''
export const BOB_PRODUCT_URL = process.env.REACT_APP_BOB_PRODUCT_URL ?? ''
export const BOB_PARTNER_URL = process.env.REACT_APP_BOB_PARTNER_URL ?? ''
export const BOB_FOUNDATION_URL = process.env.REACT_APP_BOB_FOUNDATION_URL ?? ''
export const BOB_MASTER_URL = process.env.REACT_APP_BOB_MASTER_URL ?? ''
export const BOB_LMS_URL = process.env.REACT_APP_BOB_LMS_URL ?? ''
export const BOB_FMS_BASE_URL = process.env.REACT_APP_FMS_BASE_URL ?? ''
export const BOB_FMS_BASE_URL_REAL = process.env.REACT_APP_FMS_BASE_URL_REAL ?? ''
export const BOB_OPERATION_URL = process.env.REACT_APP_BOB_OPERATION_URL ?? ''
export const LEADS_URL = process.env.REACT_APP_LEADS_URL ?? ''
export const GROUP_URL = process.env.REACT_APP_BOB_GROUP ?? ''
export const EQUITAS_URL = process.env.REACT_APP_EQUITAS_URL ?? ''
export const COMMUNICATION_URL = process.env.REACT_APP_COMMUNICATION_URL ?? ''
export const BOB_TRAVEL_URL = process.env.REACT_APP_BOB_TRAVEL_URL ?? ''

export const BOB_GOAL_ASSETS_URL = process.env.REACT_APP_BOB_GOAL_ASSETS_URL ?? ''
export const BOB_BGR_URL = process.env.REACT_APP_BGR_URL ?? ''

export const TRAINING_DECK_REF_ID = process.env.REACT_APP_TRAINING_DECK_REF_ID ?? ''

// DISABLED (VAPT #2) — both return ''. Kept so existing imports compile; the
// session-key scheme in Services/secureTransport ignores them entirely.
export const aesKey = getAesKeyHex()
export const iv = getIvString()
export { API_ENDPOINTS } from './endpoints'

export const saodEnableDate = new Date('2018/08/31')

export const Vechicle_data = [
  {
    key: 'Two Wheeler',
    value: 'two_wheeler',
    image: wheeler_2,
  },
  {
    key: 'Four Wheeler',
    value: 'four_wheeler',
    image: wheeler_4,
  },
  {
    key: 'GCV',
    value: 'gcv',
    image: gcv,
  },
  {
    key: 'PCV',
    value: 'pcv',
    image: pcv,
  },
  {
    key: 'Miscellaneous Vehicle',
    value: 'misc',
    image: misc,
  },
]

// * NICL motor insurer codes - nominee details are compulsory for these
export const niclMotorInsurers = ['NIC4W', 'NIC2W', 'NIC_4W', 'NIC_2W']

export const nomineeMandatoryInsurers = [
  'TA_2W',
  'MG4W',
  'MG2W',
  'GDPCV',
  'hdfc_4w',
  'hdfc_2w',
  'HDGCV',
  'HE4W',
  'HE2W',
  'HDFCPC',
  'RS4W',
  'RS2W',
  'SR4W',
  'MGMISC',
  'MGMMIS',
]

export const correspondingAddressInsurers = ['IL4W', 'IL2W', 'RS2W', 'RS4W']

export const GenderMap: any = {
  son: 'Male',
  daughter: 'Female',
  father: 'Male',
  mother: 'Female',
  spouse: 'Female',
}
export const RELATION = {
  SPOUSE: 'Spouse',
  FATHER: 'Father',
  MOTHER: 'Mother',
  DAUGHTER: 'Daughter',
  SON: 'Son',
  SELF: 'Self',
  WIFE: 'Wife',
}
export const insuredImage = (value: string) => {
  let output
  switch (value) {
    case 'Father':
      output = father_logo
      break
    case 'Mother':
      output = mother_logo
      break
    case 'Spouse':
      output = spouse_logo
      break
    case 'Son':
      output = son_logo
      break
    case 'Daughter':
      output = daughter_logo
      break
    case 'Self':
      output = self_logo
      break
    default:
      output = self_logo
  }
  return output
}
export const COLORS = {
  BLUE_100: '#0089CF',
  WHITE: '#fff',
  PURPLE_10: '#CCD2F0',
  BLUE_10: '#DEF0F9',
  SUCCESS: '#149529',
  BLUE_01: '#B0E4FF',
  BLUE_0: '#F8FDFF',
  BLUE_02: '#E1F5FE',
  DARK_BLUE: '#2255AB',
  GRAY_10: '#F5F5F5',
  GRAY_700: '#707070',
  BLACK: '#2C2C2C',
  GRAY_100: '#D3D3D3',
  RED_800: '#FF0000',
  LIGHR_GREEN: '#EDFFE8',
  BLUE: "#333F82",
  PINK_100: "#FDF2F2",
  PINK_200: "#F4DBDB",
  SKY_BLUE_100: "#8DBAED",
  BLUE_50: "#F3F7FA",
  BLUE_20: "#FCFCFF",
  BLUE_12: "#EFF1FC",
  BLUE_05: "#1F3F8C",
  NEW_: "#DFE4FD",
  GRAY_50: "#F2F4F6",
  YELLOW: "#FFC8104A",
}

export const allInsurers = {
  digit_fw: 'GoDigit Four wheeler',
  digit_tw: 'GoDigit 2w',
  hdfc_4w: 'HDFC ERGO General Insurance Company Four Wheeler',
  hdfc_2w: 'HDFC ERGO General Insurance Company Two Wheeler',
  HDGCV: 'HDFC GCV',
  HDPCV: 'HDFC PCV',
  raheja_4w: 'Raheja 4W',
  religare_name: 'RELIGARE',
  navi_4w: 'Navi General Fourwheeler',
  navi_2w: 'Navi General Twowheeler',
  tata_aig_4w: 'TATA AIG 4W',
  tata_aig_2w: 'TATA AIG 2W',
  SBIFW: 'SBI General Insurance Four Wheeler',
  SBITW: 'SBI General Insurance Two Wheeler',
  SBIGCV: 'SBI General Insurance GCV',
  BJ4W: 'Bajaj 4W',
  BJ2W: 'Bajaj 2W',
  BJGCV: 'Bajaj Good Carrying Vehicle',
  ITGI4W: 'ITGI 4W',
  RS4W: 'Royal Sundaram 4W',
  RS2W: 'Royal Sundaram 2W',
  SR4W: 'Shriram General Insurance 4w',
  MG4W: 'Magma Hdi Fourwheeler',
  MG2W: 'Magma Hdi Twowheeler',
  MGMISC: 'Magma Miscellaneous HDMI General Insurance',
  MGMMIS: 'MAGMA MISCELLANEOUS',
  RA4W: 'Raheja 4W',
  RA2W: 'Raheja 2W',
  LGI2W: 'Liberty General Insurance Two Wheeler',
  LGI4W: 'Liberty General Insurance Four Wheeler',
  ICI4W: 'ICICI Lombard 4W',
  ICI2W: 'ICICI Lombard 2W',
  IL4W: 'ICICI Lombard 4W',
  IL2W: 'ICICI Lombard 2W',
  IT4W: 'ITGI 4W',
  IT2W: 'ITGI 2W',
}

export const hypothecationCheckInsurers = [
  'Chola4',
  'Chola2',
  'CHGCV',
  'CHPCV',
  'SR4W',
  'MG2W',
  'MG4W',
  'RA2W',
  'RA4W',
  'raheja_4w',
  'hdfc_4w',
  'hdfc_2w',
  'TA_2W',
  'TA_4W',
  'TAGCV',
  'TAPCV',
  'TAMISC',
]

export const BOB_CUSTOMER_LOGIN_OPTIONS = [
  {
    label: 'Customer Id',
    value: 'customer',
  },
  {
    label: 'Account No.',
    value: 'account',
  },
  {
    label: 'Email Id',
    value: 'email',
  },
  {
    label: 'Mobile No.',
    value: 'mobile',
  },
]

export const tabAllowedFileFormats = ['image/*;capture=camera']
export const desktopAllowedFileFormats = [
  '.jpeg',
  '.jpg',
  '.png',
  '.pdf',
  '.docx',
  '.tif',
  '.tiff',
  '.doc',
]

export const vehicleCategory = [
  {
    label: 'Old Vehicle',
    value: 'ov',
  },
  {
    label: 'New Vehicle',
    value: 'nv',
  },
]
export const minDate = subYears(new Date(), 18)
export const minDateforChild = subDays(new Date(), 91)
export const maxDateForchild = subYears(new Date(), 25)
export const maxDate = subDays(subYears(new Date(), 85), 1)

export function formatToDollarCurrency(value: number | string): string {
  return Number(value).toLocaleString('en-IN', {
    style: 'currency',
    currency: 'USD',
  })
}

export { STORAGE_CONSTANTS } from './storage'
export {
  registrationNumRegex,
  mobileNumRegex,
  mobileNumWithOptional91Regex,
  mobileNumWithOptional91AndPlus91Regex,
  emailRegex,
  panNumRegex,
  gstRegex,
  onlyAlphabetsRegex,
  startingWithSpaceNotAllowed,
  dotNotInclude,
} from './regex'
